import React, { useMemo } from 'react';
import { Box, Heading, Text } from "@chakra-ui/react";
import { PieChart, Pie, Legend, ResponsiveContainer } from 'recharts';

const AllTicketsPieGraph = React.memo(({ title, chart, chartHeight }) => {
  const chartData = useMemo(() => chart, [chart]);

  const data = useMemo(() => [
    { name: 'Completed', value: chartData.completed, fill: 'var(--green)' },
    { name: 'No Show', value: chartData.noShow, fill: 'var(--red)' },
    { name: 'Unattended', value: chartData.unattended, fill: 'var(--orange)' },
  ], [chartData.completed, chartData.noShow, chartData.unattended]);

  return (
    <Box width="100%">
      {
        chartData.completed === 0 && chartData.noShow === 0 && chartData.unattended === 0
        ?   <Box mt="70px">
              <Text align="center" color="#535353">No data available for this Pie Chart</Text>
            </Box>
        : <>
            <ResponsiveContainer width="100%" height={chartHeight ? parseInt(chartHeight) : 300} debounce={300}>
              <PieChart width={400} height={300} >
                <Pie
                  dataKey="value"
                  startAngle={0}
                  endAngle={360}
                  data={data}
                  cx="50%"
                  cy="50%"
                  outerRadius={80}
                  innerRadius={45}
                  fill="#8884d8"
                  isAnimationActive={false}
                />
                <Legend verticalAlign="bottom" width="100%"  />
              </PieChart>
            </ResponsiveContainer>
          </>
      }
    </Box>
  );
});

export default AllTicketsPieGraph;